import axios from '@/services/axios.setup.js';

/**
 * @typedef {Object} Log
 * @property {number} account_id
 * @property {number} message_id
 * @property {number} user_id
 * @property {string} action
 * @property {Object} message Available thanks to the query, not in the original model
 * @property {number} message.id
 * @property {string} message.subject The related message subject
 * @property {Object} user Available thanks to the query, not in the original model
 * @property {number} user.id
 * @property {string} user.username The username of who made this action
 * @property {Object} account Available thanks to the query, not in the original model
 * @property {number} account.id
 * @property {string} account.alias The account on which this action was taken
 */

/**
 * @readonly
 * @enum {string}
 */
export const LogActions = {
    MessageSent: "message_sent",
    MessageForwarded: "message_forwarded",
    MessageAssigned: "message_assigned",
    MessageTrashed: "message_trashed",
    MessageRestored: "message_restored",
    MessageTagged: "message_tagged",
    MessageUntagged: "message_untagged",
    MessageRead: "message_read",
    MessageUnread: "message_unread",
    StatusChanged: "message_status_changed",
    AutoForward: "auto_forward",
    FilterAdded: "filter_added",
    FilterEdited: "filter_edited",
    FilterRemoved: "filter_removed",
}

/**
 * @type {Record<LogActions, [string, string]}
 */
export const LogActionLabelsAndIcons = {
  [LogActions.MessageSent]: ["Messaggio inviato", "fa-paper-plane"],
  [LogActions.MessageForwarded]: ["Messaggio inoltrato", "fa-share"],
  [LogActions.MessageAssigned]: ["Modificate assegnazioni", "fa-at"],
  [LogActions.MessageTagged]: ["Messaggio taggato", "fa-tag"],
  [LogActions.MessageUntagged]: ["Rimosso tag dal messaggio", "fa-times"],
  [LogActions.MessageTrashed]: ["Messaggio spostato nel cestino", "fa-trash"],
  [LogActions.MessageRestored]: ["Messaggio ripristinato dal cestino", "fa-trash-restore"],
  [LogActions.MessageRead]: ["Messaggio segnato come letto", "fa-envelope-open"],
  [LogActions.MessageUnread]: ["Messaggio segnato come non letto", "fa-envelope"],
  [LogActions.StatusChanged]: ["Stato del messaggio modificato", "fa-tasks"],
  [LogActions.AutoForward]: ["Inoltro automatico", "fa-share"],
  [LogActions.FilterAdded]: ["Filtro aggiunto", "fa-filter"],
  [LogActions.FilterEdited]: ["Filtro modificato", "fa-filter"],
  [LogActions.FilterRemoved]: ["Filtro rimosso", "fa-filter-circle-xmark"],
}

/**
 * Search in all tags.
 *
 * @param {Date | null} startDate
 * @param {Date | null} endDate
 * @param {number | null} limit
 * @param {LogActions | null} action
 * @param {number | null} user
 * @param {number | null} account
 */
export async function getAll(
  startDate = null,
  endDate = null,
  limit = null,
  action = null,
  user = null,
  account = null,
  subject = null
) {
  let params = {};

  if (startDate) params["start_date"] = startDate.toString();
  if (endDate) params["end_date"] = endDate.toString();
  if (limit) params["limit"] = limit.toString();
  if (action) params["action"] = action;
  if (user) params["user"] = user;
  if (account) params["account"] = account;
  if (subject) params["subject"] = subject;

  let res = await axios.get('/logs/', { params });
  return res.data;
}

/**
 * Get a single log, with some more data
 *
 * @param {number} id The log id
 * @returns
 */
export async function get(id) {
  let res = await axios.get(`/logs/${id}`);
  return res.data;
}

/**
 * Get a list of logs that refer to a message
 *
 * @param {number} id The message id
 * @returns
 */
export async function getForMessage(id) {
  let res = await axios.get(`/logs/message/${id}`);
  return res.data;
}
